import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
  isOpen: false,
  messageError: '',
  optionals: {},
}

const messageErrorSlice = createSlice({
  name: 'messageError',
  initialState,
  reducers: {
    setMessageErrors: (state, action: PayloadAction<any>) => {
      return action.payload
    },
    setInitMessageErrors: () => {
      return initialState
    },
  },
})
export const messageErrorAction = messageErrorSlice.actions
export default messageErrorSlice
